const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}'
const uuidPattern = new RegExp(`^${UUID}$`, 'i')
const payUrlPattern = new RegExp(
  `^https://pay\\.portalwallet\\.ru/p/${UUID}$`,
  'i',
)
const RETURN_KEY = 'gonkagame:portal:return'

export function isPortalUuid(value: unknown): value is string {
  return typeof value === 'string' && uuidPattern.test(value)
}

export function portalPayUrl(value: unknown): string | null {
  // Check the original string too: URL parsing normalizes credentials, dot paths,
  // encoded characters and whitespace that are not part of the payment contract.
  if (typeof value !== 'string' || !payUrlPattern.test(value)) return null
  const url = new URL(value)
  return url.origin === 'https://pay.portalwallet.ru' ? url.href : null
}

export function normalizePortalAmount(value: string): string | null {
  const amount = value.trim().replace(',', '.')
  if (
    !/^(?:0|[1-9]\d{0,29})(?:\.\d{1,6})?$/.test(amount) ||
    !/[1-9]/.test(amount)
  )
    return null
  return amount.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
}

export function rememberPortalReturn(attemptId: unknown): void {
  if (!isPortalUuid(attemptId)) return
  try {
    sessionStorage.setItem(RETURN_KEY, attemptId)
  } catch {
    /* URL still holds the UUID. */
  }
}

export function takePortalReturn(): string | null {
  try {
    const id = sessionStorage.getItem(RETURN_KEY)
    sessionStorage.removeItem(RETURN_KEY)
    return isPortalUuid(id) ? id : null
  } catch {
    return null
  }
}

export function clearPortalReturn(attemptId: string): void {
  try {
    if (sessionStorage.getItem(RETURN_KEY) === attemptId)
      sessionStorage.removeItem(RETURN_KEY)
  } catch {
    /* Non-financial navigation hint only. */
  }
}
